import {
  AttachmentContent,
  ImageContent,
  ImageSize,
  TextContent,
} from '@/resource/question/question.type';

const attachmentExample = new AttachmentContent([
  new TextContent('This is attachment for this question'),
  new ImageContent([
    {
      url:
        'https://mysoalan-prod.s3-ap-southeast-1.amazonaws.com/question-images/Sejarah+PT3/sejarah_form7_46.PNG',
      size: ImageSize.Half,
    },
  ]),
]);

export default attachmentExample;
